import * as R from 'ramda';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaProjectTypes } from './sagaProjectRedux';
import { push } from 'react-router-redux';
import { buildUrl, checkAllJsonItemsIsNull, getCurrentUserId, isYoutubeVideo } from '../../helpers/utility';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import { Result } from '../../redux/helpers/Ihelper';
import { ProjectEnquiry } from 'redux/sagaProject/IProjectMatrixReponse';
import AppConfig from '../../config/AppConfig';
import { UPLOAD_LIMIT } from '../../config/imageConstant';

export function* requestProjectList(action) {
    const tag = '[REQUEST_PROJECT_LIST]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.GetProjectList, jwtToken, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestProjectList response :`, response.data);
                yield put(Actions.projectListSuccess(response.data.result));
            } else {
                console.warn(`${tag} requestProjectList invalid response :`, response);
                throw new Error(JSON.stringify(response.data.error));
            }

        } else {
            throw new Error('project.NotLoggedIn');  // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestProjectList failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.projectListFailure(message));
    }
}

export function* requestProjectDetail(action) {
    const tag = '[REQUEST_PROJECT_DETAIL]';
    try {
        // step 1: perform input validation
        const projectId = action.projectId;
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const userId = yield getCurrentUserId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetProjectDetail, jwtToken, projectId, branchId, culture, userId);
            console.log(`${tag} response is : `, response);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestProjectDetail response :`, response.data);
                yield put(Actions.projectDetailSuccess(response.data.result));
            } else {
                console.warn(`${tag} requestProjectDetail invalid response :`, response);
                throw new Error(JSON.stringify(response.data.error));
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestProjectDetail failed with error :`, e.message);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.projectDetailFailure(message));
    }
}

export function* requestProjectDetailImage(action) {
    const tag = '[REQUEST_PROJECT_DETAIL_IMAGE]';
    try {
        // step 1: perform input validation
        const inputValid = false; // IDE-Help, do not delete me
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.AccountLogin, '', '', '');
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestProjectDetailImage response :`, response.data);
                yield put(Actions.projectDetailImageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestProjectDetailImage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.projectDetailImageFailure(message));
    }
}

export function* requestProjectDeleteImage(action) {
    const tag = '[REQUEST_PROJECT_DELETE_IMAGE]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me

        if (!jwtToken || !action.referenceId || R.isEmpty(action.projectImages2Delete)) {
            throw new Error('jwtToken is empty/referenceId is empty/images is empty');
        }
        else {
            inputValid = true;
        }

        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.ProjectDeleteImage, jwtToken, action.referenceId, action.projectImages2Delete, action.imageType);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestProjectDeleteImage response :`, response.data);
                // check imageType if it's coming from projectUnit should redirect with activeTab=2
                if (action.imageType === 1) {
                    yield put(Actions.requestProjectDetail(action.projectId));
                }
                else {
                    yield put(push(buildUrl(`/dashboard/project/${action.projectId}?activeTab=2`)));
                }
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestProjectDeleteImage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.projectDeleteImageFailure(message));
    }
}

export function* requestProjectMatrixBatch(action) {
    const tag = '[REQUEST_PROJECT_MATRIX_BATCH]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (!jwtToken || !branchId) {
            throw new Error('jwtToken is empty/brandId is empty');
        }
        else {
            inputValid = true;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.GetProjectMatrixBatch, jwtToken, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestProjectMatrixBatch response :`, response.data);
                yield put(Actions.projectMatrixBatchSuccess(response.data.result));

            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/brandId is empty');
        }
    }
    catch (e) {
        console.warn(`${tag} requestProjectMatrixBatch failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.projectMatrixBatchFailure(message));
    }
}

export function* requestProjectUpdateBatch(action) {
    const tag = '[REQUEST_PROJECT_UPDATE_BATCH]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);

        if (!jwtToken || !branchId) {
            throw new Error('jwtToken is empty/brandId is empty');
        }
        else {
            inputValid = true;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.ProjectUpdateBatch, jwtToken, branchId, culture, action.actionName, action.propertyList, action.defectList, action.percentage, action.salesState, action.salesAgentId, action.price, action.markUnitIsPercent, action.userId, action.projectId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestProjectUpdateBatch response :`, response.data);
                yield put(Actions.projectUpdateBatchSuccess(response.data.result));
                // yield put(Actions.requestProjectDetail(action.projectId));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is empty/brandId is empty');
        }
    }
    catch (e) {
        console.warn(`${tag} requestProjectUpdateBatch failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.projectUpdateBatchFailure(message));
    }
}

export function* requestProjectCreateProrjectProperty(action) {
    const tag = '[REQUEST_PROJECT_CREATE_PRORJECT_PROPERTY]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const userId = yield getCurrentUserId();
        if (!jwtToken || !branchId) {
            throw new Error('jwtToken is empty/brandId is empty');
        }
        else {
            inputValid = true;
        }
        if (inputValid) {
            const result = validateAddNewUnit(action);
            if (result.isValid) {
                // step 2 : validation passed..
                const response = yield call(API.CreateProrjectProperty, jwtToken, branchId, culture, action.projectId, action.unitNumber, action.unitTypeId, action.price, action.minimumPrice, action.category, userId);
                if (response.status === 200 && response.data.statusCode === 200) {
                    console.log(`${tag} requestProjectCreateProrjectProperty response :`, response.data);
                    yield put(Actions.projectCreateProrjectPropertySuccess(response.data.result));
                    yield put(Actions.requestProjectDetail(action.projectId));
                } else {
                    throw new Error(response.data.error);
                }

            } else {
                yield put(Actions.projectCreateProrjectPropertyFailure(result.errorMessages));
            }


        } else {
            throw new Error('jwtToken is empty/brandId is empty'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestProjectCreateProrjectProperty failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.projectCreateProrjectPropertyFailure(message));
    }
}


function validateAddNewUnit(unit) {
    // validate here
    const result = { isValid: false, errorMessages: [] };
    if (unit == null) { result.isValid = false; return result; }
    let isValid = true;
    const errorMessages = [];
    const reg = /^[0-9]+(?:-[0-9]+)?(,[0-9]+(?:-[0-9]+)?)*$/;
    console.log('validateAddNewUnit');
    // unitNumber
    if (!unit.unitNumber || unit.unitNumber.length <= 0) {
        errorMessages.push('error.addNewUnit.unitNumber');
        isValid = false;
    } else if ((unit.unitNumber) && !reg.test(unit.unitNumber)) {
        errorMessages.push('error.addNewUnit.invalidUnitNumber');
        isValid = false;
    }

    // price
    if (!unit.price || unit.price <= 0) {
        errorMessages.push('error.addNewUnit.price');
        isValid = false;
    }
    // minumumPrice
    if (!unit.minimumPrice || unit.minimumPrice <= 0) {
        errorMessages.push('error.addNewUnit.minimumPrice');
        isValid = false;
    }
    //
    if ((unit.price) && (unit.minimumPrice) && unit.price < unit.minimumPrice) {
        errorMessages.push('error.addNewUnit.price2');
        isValid = false;
    }

    result.isValid = isValid;
    result.errorMessages = errorMessages;
    return result;
}


export function* requestInitialProjectData(action) {
    const tag = '[REQUEST_INITIAL_PROJECT_DATA]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (!jwtToken || !branchId) {
            throw new Error('jwtToken is empty/branchId is empty');
        }
        else {
            inputValid = true;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.GetAddNewProjectData, jwtToken, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestInitialProjectData response :`, response.result);
                yield put(Actions.initialProjectDataSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestInitialProjectData failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.initialProjectDataFailure(message));
    }
}


export function* requestCreateProject(action) {
    const tag = '[REQUEST_CREATE_PROJECT]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (!jwtToken || !branchId) {
            throw new Error('jwtToken is empty/branchId is empty');
        }
        else {
            inputValid = true;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const result = validateRequestUpdateProject(action.project);
            if (result.isValid) {
                const response = yield call(API.CreateProject, jwtToken, branchId, action.project, action.userId);
                if (response.status === 200 && response.data.statusCode === 200) {
                    console.log(`${tag} requestCreateProject response :`, response.data);
                    if (action.isIFrame) {
                        yield put(push(buildUrl(`/dashboard/project/${response.data.result.propertyId}?iframe=true`)));
                    }
                    else {
                        yield put(push(buildUrl(`/dashboard/project/${response.data.result.propertyId}`)));
                    }
                } else {
                    throw new Error(response.data.error);
                }

            } else {
                yield put(Actions.updateProjectFailure(result.errorMessages));
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateProject failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateProjectFailure(message));
    }

}

export function* requestCreateProjectUnit(action) {
    const tag = '[REQUEST_CREATE_PROJECT_UNIT]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            inputValid = true;
        }
        else {
            inputValid = false;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.CreateProjectUnit, jwtToken, action.projectId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestCreateProjectUnit response :`, response.data);
                yield put(push(buildUrl(`/dashboard/project/${action.projectId}?activeTab=2`)));
                yield put(Actions.createProjectSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateProjectUnit failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createProjectUnitFailure(message));
    }
}

export function* requestUpdateProject(action) {
    const tag = '[REQUEST_UPDATE_PROJECT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (!jwtToken || !branchId) {
            throw new Error('NotLoggedIn');
        }
        const result = validateRequestUpdateProject(action.project2Change);
        if (result.isValid) {
            // step 2 : validation passed..
            console.log('sata action', action.project2Change);
            const response = yield call(API.UpdateProject, jwtToken, culture, action.project2Change, branchId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateProject response :`, response.data);
                yield put(Actions.updateProjectSuccess(response.data.result));
                // yield put(Actions.requestProjectDetail(action.project2Change.projectId));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            yield put(Actions.updateProjectFailure(result.errorMessages));
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateProject failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateProjectFailure(message));
    }
}

// function getRiaNganWaFromLandSize(landSize) {
//     if (landSize == null) {
//         return;
//     }
//     const rai = 1600;
//     const ngan = 400;
//     const sqw = 4;
//     // tsline:disable-next-line
//     let areaRai = 0;
//     let areaNgan = 0;
//     let areaWa = 0;
//     // convert rai
//     areaRai = Math.floor((landSize) / rai);
//     // convert ngan
//     areaNgan = Math.floor(Math.round((landSize) % rai) / ngan);
//     // convert wa
//     areaWa = Math.round((((landSize) % rai) % ngan) / sqw);
//     return { rai: areaRai, ngan: areaNgan, wa: areaWa };
// }
function validateRequestUpdateProject(project2Change) {
    // validate here
    const result = { isValid: false, errorMessages: [] };
    if (project2Change == null) { result.isValid = false; return result; }
    let isValid = true;
    const errorMessages = [];
    // project name
    if (!project2Change.projectName || project2Change.projectName.length <= 0 || !checkAllJsonItemsIsNull(project2Change.projectName)) {
        errorMessages.push('error.projectDetail.projectName');
        isValid = false;
    }
    // project Id
    if (!project2Change.projectRegId || project2Change.projectRegId.trim().length <= 0) {
        errorMessages.push('error.projectDetail.projectRegId');
        isValid = false;
    }
    // project types
    if (project2Change.selectedProjectTypes == null || project2Change.selectedProjectTypes.length === 0) {
        errorMessages.push('error.projectDetail.projectTypes');
        isValid = false;
    }
    // developer
    if (project2Change.companyName == null || project2Change.companyName.length <= 0 || !checkAllJsonItemsIsNull(project2Change.companyName)) {
        errorMessages.push('error.projectDetail.developer');
        isValid = false;
    }
    // total unit
    // if (project2Change.totalUnits == null || project2Change.totalUnits <= 0) {
    //     errorMessages.push('error.projectDetail.totalUnits');
    //     isValid = false;
    // }
    // province
    if (!project2Change.postalAddress3 || project2Change.postalAddress3.length <= 0) {
        errorMessages.push('error.projectDetail.province');
        isValid = false;
    }

    // district
    if (AppConfig.region !== 'is-IS' && (!project2Change.postalAddress2 || project2Change.postalAddress2.length <= 0)) {
        errorMessages.push('error.projectDetail.district');
        isValid = false;
    }
    // area
    if (AppConfig.region !== 'is-IS' && (!project2Change.postalAddress || project2Change.postalAddress.length <= 0)) {
        errorMessages.push('error.projectDetail.area');
        isValid = false;
    }
    // address
    if (!project2Change.address || project2Change.address.length <= 0 || !checkAllJsonItemsIsNull(project2Change.address)) {
        errorMessages.push('error.projectDetail.address');
        isValid = false;
    }
    // yearBuilt
    if (!project2Change.yearBuilt || project2Change.yearBuilt <= 0) {
        errorMessages.push('error.projectDetail.yearBuilt');
        isValid = false;
    }
    // yearComplete
    if (project2Change.yearComplete > 0 && project2Change.yearComplete < project2Change.yearBuilt) {
        errorMessages.push('error.projectDetail.yearComplete');
        isValid = false;
    }

    // selectedStatus
    if (!project2Change.selectedStatus || project2Change.selectedStatus.length <= 0) {
        errorMessages.push('error.projectDetail.status');
        isValid = false;
    }

    // videoLink    
    if (project2Change.videoLink && !isYoutubeVideo(project2Change.videoLink)) {
        errorMessages.push('error.projectDetail.videoLink');
        isValid = false;
    }

    // project pictures
    if(project2Change.projectGalleries && project2Change.projectGalleries.length > UPLOAD_LIMIT) {
        errorMessages.push('error.uploadLimitExceed');
        isValid = false;
    }
    
    // // landsize
    // if (!project2Change.landSize) {
    //     errorMessages.push('error.projectDetail.landSize');
    //     isValid = false;
    // } else if (project2Change.landSize <= 0) {
    //     errorMessages.push('error.projectDetail.landSize2');
    //     isValid = false;
    //     // const raiNganWa = getRiaNganWaFromLandSize(project2Change.landSize);
    //     // console.log('rai-->' , raiNganWa);
    //     // if(!raiNganWa.rai || raiNganWa.rai <= 0){
    //     //     errorMessages.push('error.projectDetail.rai');
    //     //     isValid = false;
    //     // }
    //     // if(!raiNganWa.ngan || raiNganWa.ngan <= 0){
    //     //     errorMessages.push('error.projectDetail.ngan');
    //     //     isValid = false;
    //     // }
    //     // if(!raiNganWa.wa || raiNganWa.wa <= 0){
    //     //     errorMessages.push('error.projectDetail.wa');
    //     //     isValid = false;
    //     // }

    // }

    result.isValid = isValid;
    result.errorMessages = errorMessages;
    return result;
}

export function* requestUpdateProjectUnits(action) {
    const tag = '[REQUEST_UPDATE_PROJECT_UNITS]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (!jwtToken) {
            throw new Error('jwtToken is empty');
        }
        else {
            inputValid = true;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const result = validateRequestUpdateProjectUnit(action.projectUnits2Change);
            if (result.isValid) {
                const response = yield call(API.UpdateProjectUnits, jwtToken, action.projectUnits2Change, action.projectId, culture, branchId, userId);
                if (response.status === 200 && response.data.statusCode === 200) {
                    console.log(`${tag} requestUpdateProjectUnits response :`, response.data);
                    yield put(Actions.updateProjectUnitsSuccess(response.data.result));
                } else {
                    throw new Error(response.data.error);
                }
            }
            else {
                yield put(Actions.updateProjectUnitsFailure(result.errorMessages));
            }
        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateProjectUnits failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateProjectUnitsFailure(message));
    }
}

function validateRequestUpdateProjectUnit(projectUnits2Change) {
    // validate here
    const result = { isValid: false, errorMessages: [] };
    if (projectUnits2Change == null) { result.isValid = false; return result; }
    let isValid = true;
    const errorMessages = [];
    projectUnits2Change.forEach(item => {
        // unit name
        if (!item.unitName || item.unitName.trim().length <= 0) {
            if (!R.contains('error.projectUnit.unitName', errorMessages)) {
                errorMessages.push('error.projectUnit.unitName');
            }
            isValid = false;
        }
        // unit type
        if (!item.unitType || item.unitType.trim().length <= 0) {
            if (!R.contains('error.projectUnit.unitType', errorMessages)) {
                errorMessages.push('error.projectUnit.unitType');
            }
            isValid = false;
        }
        // size
        if (item.size == null || item.size <= 0) {
            if (!R.contains('error.projectUnit.size', errorMessages)) {
                errorMessages.push('error.projectUnit.size');
            }
            isValid = false;
        }
        // floorplan pictures
        if(item.floorPlanPictures && item.floorPlanPictures.length > UPLOAD_LIMIT) {
            if (!R.contains('error.uploadLimitExceed', errorMessages)) {
                errorMessages.push('error.uploadLimitExceed');
            }
        }
        // gallery pictures
        if(item.galleryPictures && item.galleryPictures.length > UPLOAD_LIMIT) {
            if (!R.contains('error.uploadLimitExceed', errorMessages)) {
                errorMessages.push('error.uploadLimitExceed');
            }
        }
    });
    result.isValid = isValid;
    result.errorMessages = errorMessages;
    return result;
}

export function* requestDeleteProject(action) {
    const tag = '[REQUEST_DELETE_PROJECT]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken && action.projectId) {
            inputValid = true;
        }
        else {
            inputValid = false;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.DeleteProject, jwtToken, action.projectId, action.userId, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteProject response :`, response.data);
                if (action.isIFrame) {
                    // close self window (for working with SagaWAP)
                    window.close();
                }
                else {
                    yield put(push(buildUrl(`/dashboard/projects`)));
                }
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('jwtToken is invlid/projectId is not valid'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteProject failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteProjectFailure(message));
    }
}

export function* requestDeleteProjectUnit(action) {
    const tag = '[REQUEST_DELETE_PROJECT_UNIT]';
    try {
        // step 1: perform input validation
        let inputValid = false; // IDE-Help, do not delete me
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken && action.projectId) {
            inputValid = true;
        }
        else {
            inputValid = false;
        }
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.DeleteProjectUnit, jwtToken, action.projectUnitId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteProjectUnit response :`, response.data);
                yield put(push(buildUrl(`/dashboard/project/${action.projectId}?activeTab=2`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteProjectUnit failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deleteProjectUnitFailure(message));
    }
}

export function* requestGenerateProjectReport(action) {
    const tag = '[REQUEST_GENERATE_PROJECT_REPORT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateProjectReport, jwtToken, branchId, culture, action.filter, action.exportType, action.projectId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGenerateProjectReport response :`, response.data);
                yield put(Actions.generateProjectReportSuccess(response.data.result));
                window.open(`${response.data.result}`);
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGenerateProjectReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateProjectReportFailure(message));
    }
}

export function* requestCreateProjectEnquiry(action) {
    const tag = '[REQUEST_CREATE_PROJECT_ENQUIRY]';
    try {
        // step 1: perform input validation
        console.log('action', action.projectEnquiry);
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const result = validateRequestCreateProjectEnquiry(action.projectEnquiry);
        if (jwtToken || branchId || culture) {

            if (result.isValid) {
                // step 2 : validation passed..
                const response = yield call(API.requestCreateProjectEnquiry, jwtToken, action.projectEnquiry, branchId);
                if (response.status === 200 && response.data.statusCode === 200) {
                    console.log(`${tag} requestCreateProjectEnquiry response :`, response.data);
                    yield put(Actions.createProjectEnquirySuccess(response.data.result));
                    yield put(Actions.requestProjectDetail(action.projectEnquiry.propertyId));
                } else {
                    console.warn(`${tag} requestCreateProjectEnquiry invalid response :`, response);
                    throw new Error(response.data.error);
                }
            } else {

                yield put(Actions.createProjectEnquiryFailure(result.errorMessages));
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateProjectEnquiry failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createProjectEnquiryFailure(message));
    }
}

export function* requestAdvanceProjectSearch(action) {
    const tag = '[REQUEST_ADVANCE_PROJECT_SEARCH]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken || branchId || culture) {
            const response = yield call(API.requestAdvanceProjectSearch, jwtToken, branchId, culture, action.advansearch);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestAdvanceProjectSearch response :`, response.data);
                yield put(Actions.advanceProjectSearchSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestAdvanceProjectSearch failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.advanceProjectSearchFailure(message));
    }
}

export function* requestUpdateProjectSentToWeb(action) {
    const tag = '[REQUEST_UPDATE_PROJECT_SENT_TO_WEB]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateProjectSentToWeb, jwtToken, branchId, action.projectId, action.isSentToWeb, action.userId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateProjectSentToWeb response :`, response.data);
                yield put(Actions.updateProjectSentToWebSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateProjectSentToWeb failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateProjectSentToWebFailure(message));
    }
}


function validateRequestCreateProjectEnquiry(projectEnquiry: ProjectEnquiry) {
    const result: Result = {
        isValid: false,
        errorMessages: []
    };
    if (!projectEnquiry) {
        result.isValid = true;
        return result;
    }
    let isValid = true;
    const errorMessage: string[] = [];

    // contact 
    if (projectEnquiry.contactId === '') {
        errorMessage.push('error.projectEnquiry.contact');
        isValid = false;
    }

    // // propertyId 
    // if (projectEnquiry.propertyId === 0) {
    //     errorMessage.push('error.projectEnquiry.propertyType');
    //     isValid = false;
    // }

    // propertyTypeId 
    if ((!projectEnquiry.enquiryPropertyType) || projectEnquiry.enquiryPropertyType === 0) {
        errorMessage.push('error.projectEnquiry.propertyType');
        isValid = false;
    }

    // Size 
    if ((projectEnquiry.enquirySizeStart) && (projectEnquiry.enquirySizeEnd) && +projectEnquiry.enquirySizeStart > +projectEnquiry.enquirySizeEnd) {
        errorMessage.push('error.projectEnquiry.size');
        isValid = false;
    }

    // Land Size 
    if ((projectEnquiry.enquiryLandsizeStart) && (projectEnquiry.enquiryLandsizeEnd) && +projectEnquiry.enquiryLandsizeStart > +projectEnquiry.enquiryLandsizeEnd) {
        errorMessage.push('error.projectEnquiry.landSize');
        isValid = false;
    }

    // Price 
    // if ((!projectEnquiry.enquiryPriceStart !== null)) {
    //     console.log(projectEnquiry.enquiryPriceStart);
    //     errorMessage.push('error.projectEnquiry.priceStart');
    //     isValid = false;
    // }
    // if ((!projectEnquiry.enquiryPriceEnd)) {
    //     errorMessage.push('error.projectEnquiry.priceTo');
    //     isValid = false;
    // }
    if ((projectEnquiry.enquiryPriceStart) && (projectEnquiry.enquiryPriceEnd) && +projectEnquiry.enquiryPriceStart > +projectEnquiry.enquiryPriceEnd) {
        errorMessage.push('error.projectEnquiry.price');
        isValid = false;
    }


    result.isValid = isValid;
    result.errorMessages = errorMessage;
    return result;
}

export function* requestUpdatePortalSenderForProject(action) {
    const tag = '[REQUEST_UPDATE_PORTAL_SENDER_FOR_PROJECT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdatePortalSenderForProject, jwtToken, branchId, action.projectId, action.portalId, action.userId, action.isSelected);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePortalSenderForProject response :`, response.data);
                yield put(Actions.updatePortalSenderForProjectSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePortalSenderForProject failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePortalSenderForProjectFailure(message));
    }
}

export function* requestGetProjectPortals(action) {
    const tag = '[REQUEST_GET_PROJECT_PORTALS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetProjectPortals, jwtToken, branchId, action.projectId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetProjectPortals response :`, response.data);
                yield put(Actions.getProjectPortalsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetProjectPortals failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getProjectPortalsFailure(message));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(SagaProjectTypes.REQUEST_PROJECT_LIST, requestProjectList),
        takeLatest(SagaProjectTypes.REQUEST_PROJECT_DETAIL, requestProjectDetail),
        takeLatest(SagaProjectTypes.REQUEST_PROJECT_DELETE_IMAGE, requestProjectDeleteImage),
        takeLatest(SagaProjectTypes.REQUEST_PROJECT_MATRIX_BATCH, requestProjectMatrixBatch),
        takeLatest(SagaProjectTypes.REQUEST_PROJECT_UPDATE_BATCH, requestProjectUpdateBatch),
        takeLatest(SagaProjectTypes.REQUEST_INITIAL_PROJECT_DATA, requestInitialProjectData),
        takeLatest(SagaProjectTypes.REQUEST_CREATE_PROJECT, requestCreateProject),
        takeLatest(SagaProjectTypes.REQUEST_PROJECT_CREATE_PRORJECT_PROPERTY, requestProjectCreateProrjectProperty),
        takeLatest(SagaProjectTypes.REQUEST_CREATE_PROJECT_UNIT, requestCreateProjectUnit),
        takeLatest(SagaProjectTypes.REQUEST_UPDATE_PROJECT, requestUpdateProject),
        takeLatest(SagaProjectTypes.REQUEST_UPDATE_PROJECT_UNITS, requestUpdateProjectUnits),
        takeLatest(SagaProjectTypes.REQUEST_DELETE_PROJECT, requestDeleteProject),
        takeLatest(SagaProjectTypes.REQUEST_DELETE_PROJECT_UNIT, requestDeleteProjectUnit),
        takeLatest(SagaProjectTypes.REQUEST_GENERATE_PROJECT_REPORT, requestGenerateProjectReport),
        takeLatest(SagaProjectTypes.REQUEST_CREATE_PROJECT_ENQUIRY, requestCreateProjectEnquiry),
        takeLatest(SagaProjectTypes.REQUEST_ADVANCE_PROJECT_SEARCH, requestAdvanceProjectSearch),
        takeLatest(SagaProjectTypes.REQUEST_UPDATE_PROJECT_SENT_TO_WEB, requestUpdateProjectSentToWeb),
        takeLatest(SagaProjectTypes.REQUEST_UPDATE_PORTAL_SENDER_FOR_PROJECT, requestUpdatePortalSenderForProject),
        takeLatest(SagaProjectTypes.REQUEST_GET_PROJECT_PORTALS, requestGetProjectPortals),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaProject/sagaProjectSaga.ts